import HeroSection from "../sections/HeroSection";
import About from "../sections/About";
import Projects from "../sections/Projects";
import Services from "../sections/Services";
import Clients from "../sections/Clients";
import Contact from "../sections/Contact";
const Navigation = () => {
  return (
    <>
      <HeroSection />
      <About />
      <Projects />
      <Services />
      <Clients />
      <Contact />
    </>
  );
};

export default Navigation;
